import { CreateCommand } from './create'
import { UpdateCommand } from './update'
import { DeleteCommand } from './delete'
import { Command } from 'commander'

const registryCommands = [CreateCommand, UpdateCommand, DeleteCommand]

const registryDomain = new Command('registry')
registryDomain.description('Manage your scalar registry')
registryCommands.forEach((command) => registryDomain.addCommand(command()))
export default registryDomain
